module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar"
  }, [_vm._m(0), _vm._v(" "), (_vm.$auth.user().roles[0].name !== 'project-responsible') ? _c('div', {
    staticClass: "menu-items"
  }, [_c('router-link', {
    staticClass: "menu-item",
    attrs: {
      "tag": "div",
      "to": {
        name: 'Index'
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-fw fa-th-large"
  })]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("\n                Overblik\n            ")])]), _vm._v(" "), (_vm.$auth.user().roles[0].name !== 'department-responsible') ? _c('router-link', {
    staticClass: "menu-item",
    class: {
      'router-link-exact-active': _vm.subIsActive('/oekonomi')
    },
    attrs: {
      "tag": "div",
      "to": {
        name: 'EconomyLearning'
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-fw fa-wallet"
  })]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("\n                Økonomi\n            ")])]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "menu-item",
    class: {
      'router-link-exact-active': _vm.subIsActive('/kunder')
    },
    attrs: {
      "tag": "div",
      "to": {
        name: 'CustomersLearning'
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-fw fa-briefcase"
  })]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("\n                Kunder\n            ")])]), _vm._v(" "), _c('router-link', {
    staticClass: "menu-item",
    class: {
      'router-link-exact-active': _vm.subIsActive('/opgaver')
    },
    attrs: {
      "tag": "div",
      "to": {
        name: 'ProjectsLearning'
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-fw fa-clipboard-list-check"
  })]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("\n                Opgaver\n            ")])]), _vm._v(" "), _c('router-link', {
    staticClass: "menu-item",
    class: {
      'router-link-exact-active': _vm.subIsActive('/medarbejdere')
    },
    attrs: {
      "tag": "div",
      "to": {
        name: 'EmployeesLearning'
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-fw fa-users"
  })]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("\n                Medarbejdere\n            ")])]), _vm._v(" "), _c('router-link', {
    staticClass: "menu-item",
    class: {
      'router-link-exact-active': _vm.subIsActive('/ansvarlige')
    },
    attrs: {
      "tag": "div",
      "to": {
        name: 'Responsibles'
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-fw fa-user-hard-hat"
  })]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("\n                Ansvarlige\n            ")])]), _vm._v(" "), (_vm.$auth.user().roles[0].name !== 'department-responsible') ? _c('router-link', {
    staticClass: "menu-item",
    class: {
      'router-link-exact-active': _vm.subIsActive('/potentiale')
    },
    attrs: {
      "tag": "div",
      "to": {
        name: 'Potential'
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fas fa-fw fa-star"
  })]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("\n                Potentiale\n            ")])]) : _vm._e(), _vm._v(" "), (_vm.$auth.user().roles[0].name !== 'user' && _vm.$auth.user().roles[0].name !== 'department-responsible') ? _c('router-link', {
    staticClass: "menu-item",
    attrs: {
      "tag": "div",
      "to": {
        name: 'Settings'
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-fw fa-cog"
  })]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("\n                Indstillinger\n            ")])]) : _vm._e(), _vm._v(" "), (_vm.$auth.user().roles[0].name === 'super-admin') ? _c('router-link', {
    staticClass: "menu-item",
    class: {
      'router-link-exact-active': _vm.subIsActive('/entreprise')
    },
    attrs: {
      "tag": "div",
      "to": {
        name: 'Enterprise'
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-fw fa-tools"
  })]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("\n                Entreprise\n            ")])]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "menu-item",
    attrs: {
      "tag": "div",
      "to": {
        name: 'BudgetPlanning'
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-fw fa-money-check-edit-alt"
  })]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("\n                Læg budget\n            ")])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('router-link', {
    staticClass: "menu-item tips",
    class: {
      'router-link-exact-active': _vm.subIsActive('/mulige-indsatser')
    },
    attrs: {
      "tag": "div",
      "to": {
        name: 'PossibleEfforts'
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-fw fa-clock"
  })]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("\n                Mulige indsatser\n            ")])]), _vm._v(" "), _c('router-link', {
    staticClass: "menu-item tips",
    attrs: {
      "tag": "div",
      "to": {
        name: 'Tips'
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-fw fa-lightbulb"
  })]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("\n                Tips & tricks\n            ")])])], 1) : _c('div', [_vm._v("\n        Du er logget ind som opgaveansvarlig og har udelukkende adgang til din egen personlige værdikæde.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [(_vm.lastSync) ? _c('div', {
    staticClass: "last-sync"
  }, [_vm._v("\n            Data opdateret:\n            "), _c('br'), _vm._v("\n            " + _vm._s(_vm.lastSync) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "user",
    on: {
      "click": _vm.logout
    }
  }, [_c('div', {
    staticClass: "avatar"
  }, [_vm._v("\n                " + _vm._s(_vm.initials) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n                    " + _vm._s(_vm.$auth.user().name) + "\n                ")]), _vm._v(" "), (_vm.$store.state.config.companyMeta) ? _c('div', {
    staticClass: "company"
  }, [_vm._v("\n                    " + _vm._s(_vm.$store.state.config.companyMeta.name) + "\n                ")]) : _vm._e()])]), _vm._v(" "), (_vm.$auth.user().roles[0].name === 'super-admin') ? _c('router-link', {
    staticClass: "super-admin-options",
    attrs: {
      "tag": "div",
      "to": {
        name: 'ChangeCompany'
      }
    }
  }, [_c('div', {
    staticClass: "change-company"
  }, [_c('i', {
    staticClass: "fas fa-building fa-fw"
  }), _vm._v("\n                Skift virksomhed\n            ")])]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/proebitda_logo_color.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "5px 0",
      "margin": "10px 0",
      "display": "flex",
      "justify-content": "center",
      "align-items": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "1px",
      "width": "100%",
      "background": "rgba(255,255,255,0.15)"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1313447a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/Sidebar.vue
// module id = 806
// module chunks = 0